module.exports = __webpack_public_path__ + "static/open-sans-v17-latin-italic-a038c4d564d9c354a6c45a1da0cc414c.ttf";